import { createStyles, WithStyles, withStyles } from "@material-ui/core/styles";
import * as React from "react";

import { Link, RelodeTheme, Text } from "../";
import { camelize } from "../utils";

const styles = (theme: RelodeTheme) =>
    createStyles({
        root: {
            display: "flex",
            alignItems: "center",
            textTransform: "none",
            fontSize: 16,
        },
        spaceAfter: {
            marginRight: "5px",
        },
        undo: {
            fontSize: "14px",
        },
    });

interface Props extends WithStyles<typeof styles> {
    filterName: string;
    handleFilter?: (e?) => void;
}

export const RefinedByListItem = withStyles(styles)((props: Props) => {
    const { classes, filterName, handleFilter } = props;

    return (
        <Text className={classes.root} variant="body2" gutterBottom>
            <span
                data-cy={`${camelize(filterName)}-refinedFacet-text`}
                className={classes.spaceAfter}
            >
                {filterName}
            </span>
            (
            <Link
                data-cy={`${camelize(filterName)}-refinedFacet-undo`}
                className={classes.undo}
                highlightType="internal"
                gutterBottom={false}
                onClick={() => handleFilter && handleFilter(undefined)}
            >
                undo
            </Link>
            )
        </Text>
    );
});
